<template>
  <v-card
    class="mx-auto w-100 d-flex overflow-hidden"
    style="height: 70vh !important"
    flat
    :disabled="loading"
  >
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card
      :style="{ width: mobile ? (drawer ? '80%' : '94%') : '100%' }"
      class=""
    >
      <app-bar
        v-model="drawer"
        @reset="resetData"
        :model.sync="model"
        :choseModel.sync="choseModel"
      />
      <chat-bot-message v-model="chats" :endMessage="endMessage" />
      <send-box-bot
        @send="sendMessage"
        v-model="chats.message"
        :loading="mLoading"
        :limited="limited"
        :endMessage="endMessage"
      />
    </v-card>

    <list-chat-bot
      :style="{ width: mobile ? (drawer ? '20%' : '6%') : '100%' }"
      v-if="mobile"
      style="height: 70vh !important"
      v-model="drawer"
      @reset="resetData"
      @click="getArchiveChat"
    />

    <list-chat-bot-mobile
      v-else
      v-model="drawer"
      @reset="resetData"
      @click="getArchiveChat"
    />
  </v-card>
</template>

<script>
import appBar from "./components/appBar.vue";
import ListChatBot from "./components/listChatBot.vue";
import chatBotMessage from "./components/chatBotMessage.vue";
import sendBoxBot from "./components/sendBoxBot.vue";
import ChatServices from "../../../utilities/ChatServices";
import ListChatBotMobile from "./components/listChatBotMobile.vue";
export default {
  components: {
    sendBoxBot,
    appBar,
    ListChatBot,
    chatBotMessage,
    ListChatBotMobile,
  },
  name: "chatBot",

  data() {
    return {
      drawer: false,
      chatServices: null,
      // model
      choseModel: null,
      model: [],
      limited: false,

      chats: {
        data: [],
        chat_id: null,
        user_id: null,
        message: null,
        me: null,
        ai: "",
        model: null,
      },

      // messages
      message: "",
      mLoading: false,
      loading: false,
      endMessage: true,
    };
  },

  mounted() {
    this.chatServices = new ChatServices();
    this.getUser();
  },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },

  methods: {
    async getUser() {
      this.loading = true;
      try {
        const { data } = await this.$api.get(this.$coreApi2 + "/core");
        const userId = data.data.user[0].id;
        this.chats.user_id = userId;
        this.socketMessage(userId);
      } catch (err) {
        console.error("خطا در getUserInfo:", err);
        this.limited = true;
        this.chats.ai = "مشکل در دریافت آیدی کاربر";
        throw err;
      } finally {
        this.loading = false;
      }
    },

    // socket
    async socketMessage(userId) {
      // let userId = this.chats.user_id;
      console.log(userId);

      if (!userId) {
        console.error("userId نامعتبر است!");
        this.$toast.error("خطا در دریافت اطلاعات کاربر!");
        return;
      }

      let silenceTimeout;
      this.$echo.leave(`chat.${userId}`);
      this.$echo.private(`chat.${userId}`).listen(".message", (e) => {
        try {
          // limited
          if (e?.[0].status == 429) {
            this.endMessage = true;
            this.$toast.error("محدودیت مدل انتخابی");
            this.limited = true;
            this.chats.ai =
              "مدل انتخابی دچار محدودیت استفاده شده برای استفاده از مدل های دیگر استفاده کنید";
            return;
          }

          // finished

          if (e?.[0]?.choices?.[0]?.finish_reason === "stop") {
            this.endMessage = true;
            return;
          }

          // if (e?.[0]?.finished) {
          //   this.endMessage = true;
          //   return;
          // }

          const content = e[0]?.choices?.[0]?.delta?.content;
          if (typeof content === "string") {
            this.chats.ai += content;
          }
        } catch {
          this.$toast.error("محدودیت مدل انتخابی");
          this.endMessage = true;
          this.limited = true;
          this.chats.ai =
            "مدل انتخابی دچار محدودیت استفاده شده برای استفاده از مدل های دیگر استفاده کنید";
        }
      });
    },

    // send messages
    async sendMessage() {
      // loading
      this.mLoading = true;
      this.endMessage = false;

      // set first need
      let message = this.chats.message;
      let id = this.chats.chat_id;
      let model = this.choseModel.model;
      this.chats.me = message;
      this.chats.message = "";

      try {
        await this.chatServices
          .sendNewMessage(message, model, id)
          .then(({ data }) => {
            this.chats.message = "";
            this.chats.chat_id = data.data.chat_id;
          })
          .catch((err) => {
            this.chats.message = message;
            this.chats.me = null;
            this.endMessage = true;
            this.$toast.error("مشکلی در ارسال پیام وجود دارد");
          });
      } catch {
        this.chats.message = message;
        this.chats.me = null;
        this.endMessage = true;

        this.$toast.error("مشکلی در ارسال پیام وجود دارد");
      } finally {
        this.mLoading = false;
      }
    },

    // clean data
    resetData(model) {
      let newModel = model ?? this.choseModel;
      this.endMessage = true;
      this.choseModel = newModel;
      this.$toast.info("چت جدید برای شما آمده شد");
      this.chats = {
        data: [],
        chat_id: null,
        user_id: null,
        message: null,
        me: null,
        ai: "",
        model: null,
      };
      this.mLoading = false;
      this.getUser();

      this.limited = false;
    },

    // getArchive chats
    async getArchiveChat(id, model) {
      this.loading = true;
      try {
        // reset data
        this.chats.data = [];
        this.chats.ai = "";
        this.chats.me = "";
        this.endMessage = true;
        this.limited = false;
        this.drawer = false;

        //  get data
        await this.chatServices.getArchiveChat(id).then(({ data }) => {
          let chats = data.data;
          this.chats.chat_id = chats[0].chat_id;

          chats.map((item) => {
            this.chats.data.push({
              content: item?.message,
              me: item?.role == "user" ? true : false,
            });
          });
          this.$toast.success("سوابق گفنگوی شما بازگردانده شد");
        });
      } catch {
        this.$toast.error("مجدد امتحان کنید");
        this.limited = true;
        this.chats.ai =
          "مشکلی در برگرداندن سوابق گفتگو وجود دارد مجدد تلاش کنید";
      } finally {
        this.loading = false;
        this.choseModel =
          this.model.find((item) => item.model === model) ?? this.model[0];
      }
    },
  },

  watch: {
    endMessage(val) {
      if (val && this.chats?.ai?.length > 0) {
        let me = this.chats.me;
        let ai = this.chats.ai;
        this.chats.data.push({
          content: me,
          me: true,
        });
        this.chats.data.push({
          content: ai,
          me: false,
        });
        this.chats.me = "";
        this.chats.ai = "";
      }
    },
  },
};
</script>

<style></style>
